/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tag': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M126 63.387l-.008-28.789c.008-5.3-4.293-9.59-9.59-9.59L87.613 25a9.565 9.565 0 0 0-6.785 2.813L28.7 79.946c-3.601 3.594-3.601 9.437 0 13.03l29.32 29.325c3.602 3.598 9.438 3.598 13.035 0l52.13-52.133A9.56 9.56 0 0 0 126 63.387zm-22.363-16.023a6.91 6.91 0 0 1 0-9.773c2.7-2.7 7.074-2.7 9.777 0a6.91 6.91 0 0 1 0 9.773 6.915 6.915 0 0 1-9.777 0z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
